import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Amplify from "aws-amplify";

Amplify.configure({
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
});


console.log("aws_cognito_region:"+ process.env.REACT_APP_AWS_COGNITO_REGION);
console.log("aws_user_pools_id:"+ process.env.REACT_APP_AWS_USER_POOLS_ID);
console.log("aws_user_pools_web_client_id:"+ process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID);

console.log("REACT_APP_API_PREFIX:"+ process.env.REACT_APP_API_PREFIX);



ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
